module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lockscreen-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-body box-profile"
  }, [_c('img', {
    staticClass: "profile-user-img img-responsive img-circle",
    attrs: {
      "src": require("../../../static/img/avatar5.png"),
      "alt": "User profile picture"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted text-center"
  }, [_vm._v(_vm._s(_vm.roles))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.handleEdit()
      }
    }
  }, [_c('b', [_vm._v("修改密码")])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "70%",
      "top": "20%",
      "show-close": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('div', {
    staticClass: "box-header with-border",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("修改密码")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "120px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "旧密码",
      "prop": "oldPassword",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.addForm.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "oldPassword", $$v)
      },
      expression: "addForm.oldPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "newPassword",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "newPassword", $$v)
      },
      expression: "addForm.newPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "prop": "confirmPassword",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "confirmPassword", $$v)
      },
      expression: "addForm.confirmPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33e5efc0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Profile.vue
// module id = 1760
// module chunks = 2